<script lang="ts">
    import type { TopInfo } from '@shared/types/types';

    interface Props {
        infos: TopInfo[] | undefined;
        variant?: 'standard' | 'clean';
        multipleSizes?: boolean;
    }

    let { infos, variant = 'standard', multipleSizes = false }: Props = $props();

    const containerClass = $derived(['reptile-top-info', { 'reptile-top-info--clean': variant === 'clean' }]);
    const valueClass = $derived(['reptile-top-info__value', { 'reptile-top-info__value--clean': variant === 'clean' }]);
</script>

{#if infos?.length && multipleSizes}
    <p class="reptile-top-info reptile-top-info--multiple-sizes">Mehrere Größen</p>
{:else if infos?.length}
    <dl class={containerClass}>
        {#each infos.slice(0, 3) as info (info)}
            <div class="reptile-top-info__item">
                <dd class={valueClass}>
                    {info.value}
                </dd>
                <dt class="reptile-top-info__label">{info.label}</dt>
            </div>
        {/each}
    </dl>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    /**
 *
 *
 *
 */
    .reptile-top-info {
        border-top: tokens.$oc-semantic-border-width-100 solid tokens.$oc-semantic-color-background-disabled;
        border-bottom: tokens.$oc-semantic-border-width-100 solid tokens.$oc-semantic-color-background-disabled;
        display: flex;
        flex-direction: column;
        gap: tokens.$oc-semantic-spacing-absolute-25;
        font: tokens.$oc-semantic-font-copy-75;
        padding-top: tokens.$oc-semantic-spacing-absolute-50;
        padding-bottom: tokens.$oc-semantic-spacing-absolute-50;

        &__item {
            @include mixins.ellipsis(nowrap);
        }

        &__label,
        &__value {
            display: inline;
        }

        &__value {
            font-weight: tokens.$oc-base-font-weight-bold;

            &--clean {
                font-weight: tokens.$oc-base-font-weight-regular;
                color: tokens.$oc-semantic-color-text-default;
            }
        }

        &--clean {
            border: none;
            padding-top: 0;
            padding-bottom: 0;
        }

        &--multiple-sizes {
            /**
 *
 *
 */
            display: block;
            margin: 0;
            border: none;
            padding-top: 0;
            padding-bottom: 0;
            @include mixins.ellipsis(nowrap);
        }
    }
</style>
